<ng-container *transloco="let t">
  @if (!isLoggedIn) {
    <p>
      {{
        t(
          'Join the YES and get access to the most beautiful jewelry, lots of inspiration and history of your orders.'
        )
      }}
    </p>

    <a app-button [routerLink]="'/register' | translateRoute | addLocale">{{
      t('Join Us')
    }}</a>
    <a
      app-button="primary-stroked"
      [routerLink]="'/login' | translateRoute | addLocale"
      >{{ t('Log In') }}</a
    >
  } @else {
    <a app-button [routerLink]="'/panel' | addLocale">{{ t('Account') }}</a>
  }
  <div class="quick-links">
    <a [routerLink]="'/stores' | translateRoute | addLocale">
      <svg-icon key="store" size="sm"></svg-icon>
      {{ t('Store locator') }}
    </a>

    <app-locale-switcher [noLabel]="true" appearance="menu"></app-locale-switcher>
    <!--    <a routerLink="/kontakt">-->
    <!--      <svg-icon key="phone" size="sm"></svg-icon>-->
    <!--      {{ t('Help and contact') }}-->
    <!--    </a>-->

    <!--    <a href="">{{ t('YES Club app') }}</a>-->
    <!--    <a href="">{{ t('Gift card') }}</a>-->
  </div>
</ng-container>
